<template>
    <div class="paper-wrapper d-flex align-items-center justify-content-center">
        <!-- <Header label="Recover Highered user" overlap="small" /> -->
        <Paper slot="center" class="paper p-5 d-flex flex-column align-items-center shadow" padding>
            <div class="logo w-100 d-flex justify-content-center">
                <img :src="logo" alt="logo" />
            </div>

            <div v-if="isDefaultState()" class="wrapper">
                <div class="d-flex justify-content-center">
                    <h6 class="mb-3 primary-color">
                        {{ $t('recoverpassword.createPassword') }}
                    </h6>
                </div>

                <form class="w-100" @submit.prevent="onResetPassword">
                    <TextField
                        v-model="password"
                        :label="$t('recoverpassword.newPasswordLabel')"
                        :placeholder="$t('recoverpassword.newPasswordPlaceholder')"
                        type="password"
                        margin
                        padding
                        required
                    />
                    <TextField
                        v-model="confirmPassword"
                        :label="$t('recoverpassword.confirmPasswordLabel')"
                        :placeholder="$t('recoverpassword.confirmPasswordPlaceholder')"
                        type="password"
                        padding
                        required
                        :error="errorMessage !== ''"
                        :helperText="errorMessage"
                    />
                    <BaseButton class="mt-4 w-100" variant="primary">{{
                        $t('recoverpassword.resetPasswordButton')
                    }}</BaseButton>
                </form>
            </div>
            <div
                v-else-if="isLoadingState()"
                class="progress-wrapper p-5 d-flex flex-column align-items-center justify-content-center"
            >
                <Spinner class="primary-color" size="lg" />
                <h6 class="caption mt-3">
                    {{ $t('recoverpassword.resettingPassword') }}
                </h6>
            </div>
            <ErrorModule v-show="isErrorState()" @stateChange="changeState" />
            <SuccessModule v-if="isSuccessState()" />
        </Paper>
    </div>
</template>

<script>
// Miscelleanous
import states from './states';
import Logo from '~/assets/img/HigheredLogo.svg';
import { isInvalidToken, passwordResetErrorMapper } from '~/utils/errors/authErrorMapper';

// Components
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import Spinner from '~/components/builders/Spinner';

// Page specific components
import ErrorModule from './components/ErrorModule';
import SuccessModule from './components/SuccessModule';

export default {
    name: 'RecoverPassword',
    components: { Header, MainLayout, Spinner, ErrorModule, SuccessModule },
    data: function() {
        return {
            logo: Logo,
            state: states.DEFAULT,
            userId: this.$route.query.userId || '',
            token: decodeURI(this.$route.query.token || ''),
            password: '',
            confirmPassword: '',
            errorMessage: '',
            isLoading: false,
        };
    },
    methods: {
        isDefaultState() {
            return this.state === states.DEFAULT;
        },
        isSuccessState() {
            return this.state === states.SUCCESS;
        },
        isErrorState() {
            return this.state === states.ERROR;
        },
        isLoadingState() {
            return this.state === states.LOADING;
        },
        setState(state) {
            this.state = state;
        },
        validateQueryParamters() {
            // Show not be able to enter this page unless 'userId' and 'token' is
            // provided in query
            if (!this.userId || !this.token) {
                this.$router.push(this.$URLS.findjobs);
            }
        },
        onResetPassword() {
            // Check if password and confirm password is equal
            if (this.password !== this.confirmPassword) {
                this.errorMessage = this.$t('recoverpassword.passwordsNotMatching');
                return;
            }

            this.state = states.LOADING;

            this.$interfaces.user['reset-password']
                .post({
                    body: {
                        token: this.token,
                        userId: this.userId,
                        password: this.password,
                    },
                })
                .then(() => {
                    this.state = states.SUCCESS;
                })
                .catch(error => {
                    if (isInvalidToken(error)) {
                        this.state = states.ERROR;
                        return;
                    }
                    this.errorMessage = passwordResetErrorMapper(error);
                    this.state = states.DEFAULT;
                });
        },
        changeState(state) {
            this.state = state;
        },
    },
    mounted() {
        this.validateQueryParamters();
        this.$interfaces.logInModule.setDisabledPopup();
    },
};
</script>

<style scoped>
.paper-wrapper {
    width: 100vw;
    height: 100vh;
}
.paper {
    max-width: 500px;
    width: 400px;
    margin: auto;
}
.wrapper {
    width: 100%;
    max-width: 800px;
    margin: auto;
}
.progress-wrapper {
    min-height: 175px;
}

.logo {
    height: 60px;
}

@media only screen and (max-width: 600px) {
    .paper {
        width: 100vw;
        height: 100vh;

        padding: 36px !important;
    }
}
</style>
